"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CDN_BASE_URL = process.env.REACT_APP_ASSETS_CDN_URL;
/**
 * @param route Start route with a '/'
 * @returns
 */

exports.generateCDNBaseUrl = function (route) {
  return CDN_BASE_URL + route;
}; //# sourceMappingURL=AdminUrl copy.js.map